import React from 'react';
import Cars from '../../containers/Cars/Cars';

const CarsPage = () => {
  return <Cars />;
};

export default CarsPage;
